export const identProviders = Object.assign({
  IDNOW: 'IDNow',
  POST: 'Post',
  EXPORO: 'Exporo',
});

Object.freeze(identProviders);

export const legitimationDocTypes = Object.assign({
  ID: { title: 'ID card', value: 'id_card' },
  PASSPORT: { title: 'Passport', value: 'Passport' },
});

Object.freeze(legitimationDocTypes);

export const identStatus = Object.assign({
  OPEN: { title: 'Open', value: 'open' },
  SUCCESS: { title: 'Success', value: 'success' },
});

Object.freeze(identStatus);



// WEBPACK FOOTER //
// ./src/enum/ident/IdentEnum.js